import { GET, PATCH, POST } from "../../../helper/xbi4RestFunctions";
export const createPersonalFaq = async (
  org_id: any,
  org_user_id: any,
  data: any
) => {
  const path = `/orgs/${org_id}/user/${org_user_id}/personal_query`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
